import Currency from '@Bill/sections/Currency'

export default {
  components: {
    Currency,
  },
}
